import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getPaisListSuccess(pais) {
  return {type: types.LOAD_PAIS_LIST_SUCCESS, pais};
}



export function getPaisList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PaisApi.getPaisList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(pais => {                  
                  dispatch(getPaisListSuccess(pais));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getPaisSuccess(catalogo) {
  return {type: types.LOAD_PAIS_SUCCESS, catalogo};
}

export function getPais(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().PaisApi.getPais(id, token).then(pais => {   
        dispatch(getPaisSuccess(pais));
        return pais;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(pais) {
  return {type: types.SAVE_PAIS_SUCCESS, pais};
}


export function save(pais, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PaisApi.save(pais, token).then(paisGuardado => {   
    dispatch(saveSuccess(paisGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getPaisComboSuccess(datos) {
  return {type: types.GET_PAISS_COMBO_SUCCESS, datos};
}

export function getPaisCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().PaisApi.getPaisCombo(token).then(datos => {   
        
      dispatch(getPaisComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(pais) {
  return {type: types.BORRAR_PAIS_SUCCESS, pais};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PaisApi.borrar(id, token ).then(pais => {
               
                  dispatch(borrarSuccess(pais));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(pais) {
  return {type: types.ACTIVAR_PAIS_SUCCESS, pais};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PaisApi.activar(id, token).then(pais => {
               
                  dispatch(activarSuccess(pais));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_PAIS, filtro};
}



